  <app-input-group>
    <label appLabel>{{ 'common.date.date' | translate }}</label>
    <input type="date" appInputDate [(ngModel)]="date" readonly>
  </app-input-group>
  <form [formGroup]="form">
    <app-input-group>
      <label class="ec-toggle-label">
        {{ 'timeSeries.missing.wantsDataLocked' | translate }}
        <app-toggle formControlName="wantsDataLocked"></app-toggle>
      </label>
    </app-input-group>
  <app-timeseries-form
    [timeSeries]="timeSeries"
    [timeSeriesAverage]="timeSeriesAverage"
  ></app-timeseries-form>
</form>
